import Flex from '~/common/components/Flex';

import CrudGridFilter from './Filter';

const findFilterValue = (fieldName, currentFilters) => {
  const foundFilter = currentFilters.find(
    (filter) => filter.fieldName === fieldName,
  );
  return foundFilter ? foundFilter.value : [];
};

type FilterMenuProps = {
  filters?: any[];
  currentFilters?: any;
  onFilterChange?: (...args: any[]) => any;
};

export default function FilterMenu({
  filters,
  currentFilters,
  onFilterChange,
}: Readonly<FilterMenuProps>) {
  const handleFilterChange = (filter, value) => {
    const { fieldName, operator, evaluateFilter } = filter;
    const findFilterIndex = currentFilters.findIndex(
      (filter) => filter.fieldName === fieldName,
    );
    if (findFilterIndex > -1) {
      const newFilters = [...currentFilters];
      if (value.length > 0) {
        newFilters[findFilterIndex].value = value;
      } else {
        newFilters.splice(findFilterIndex, 1);
      }
      onFilterChange(newFilters);
    } else {
      onFilterChange([
        ...currentFilters,
        {
          fieldName,
          value: value,
          operator: operator,
          evaluateFilter,
        },
      ]);
    }
  };

  return (
    <Flex
      flexDirection={'row-reverse'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      {filters.map((filter) => (
        <CrudGridFilter
          key={JSON.stringify(filter)}
          filter={filter}
          handleFilterChange={handleFilterChange}
          currentFilter={findFilterValue(filter.fieldName, currentFilters)}
        />
      ))}
    </Flex>
  );
}
